import { render, staticRenderFns } from "./premium-lock-screen.vue?vue&type=template&id=baccbf5e&"
import script from "./premium-lock-screen.vue?vue&type=script&lang=js&"
export * from "./premium-lock-screen.vue?vue&type=script&lang=js&"
import style0 from "./premium-lock-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports